<template>
  <div class="region-selection">
    <!-- ✅ Показываем спиннер, пока идёт загрузка -->
    <div v-if="isLoading" class="spinner"></div>
    <ul v-else>
      <CityItem v-for="city in cities" :key="city._id" :city="city" />
    </ul>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import CitiesService from "../api/CitiesService";
import CityItem from "./CityItem.vue";

const cities = ref([]);
const isLoading = ref(true); // ✅ Спиннер активен, пока идёт загрузка

async function loadCities() {
  try {
    cities.value = await CitiesService.fetchCities();
  } catch (error) {
    console.error("Ошибка при загрузке городов:", error);
  } finally {
    isLoading.value = false; // ✅ Выключаем спиннер после загрузки
  }
}

onMounted(loadCities);
</script>

<style scoped>
.region-selection {
  background: #353535;
  padding: 30px;
  border-radius: 10px;
  width: 250px;
  height: 300px;
  overflow-y: auto;
  color: white;
  scrollbar-width: none
}

.region-selection::-webkit-scrollbar {
  display: none;
}

/* ✅ Спиннер */
.spinner {
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top: 4px solid #fff;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  animation: spin 1s linear infinite;
  margin: 20px auto;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

ul {
  list-style: none;
  padding: 0;
  padding-top: 0px;
  margin-top: 0; 
}

</style>